/**
 * API Configuration
 * Centralized configuration for all API endpoints
 */

export const CHATBOT_API_BASE_URL = process.env.REACT_APP_API_CHATBOT_URL;
export const MAIN_API_BASE_URL = process.env.REACT_APP_API_URL;
export const OPENAI_MODEL = process.env.REACT_APP_OPENAI_MODEL;

/**
 * Validate if a string is a valid MongoDB ObjectId
 * @param {string} id - ID to validate
 * @returns {boolean} True if valid ObjectId format
 */
export const isValidObjectId = (id) => {
    return /^[0-9a-fA-F]{24}$/.test(id);
};
